import { c as _c } from "react/compiler-runtime";
import { usePassengerRoomCountTour } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/passenger-room-count-input/hooks";
import { PassengerRoomCountTour } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/passenger-room-count-input/passenger-room-count-tour/passenger-room-count-tour";
import { PassengerRoomCountInputPropertiesType } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/passenger-room-count-input/types";
import { FC, useEffect } from "react";
export const PassengerRoomCountInput: FC<PassengerRoomCountInputPropertiesType> = properties => {
  const $ = _c(21);
  const {
    passengerInitial,
    onChange: onChangePassengers,
    chipsColor: t0,
    iconColor,
    PopoverClassName
  } = properties;
  const chipsColor = t0 === undefined ? "secondary" : t0;
  let t1;
  if ($[0] !== passengerInitial) {
    t1 = {
      initialValues: passengerInitial
    };
    $[0] = passengerInitial;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onSubmitPassengerCount,
    passengerCount,
    passengerCountList,
    passengerCountTitle,
    passengerCountResult,
    onChange,
    onDeletePassengerCountList,
    onAddPassengerCountList,
    onChangeChildAge,
    totalPassenger,
    onClosePassengerButton
  } = usePassengerRoomCountTour(t1);
  let t2;
  if ($[2] !== onChangePassengers || $[3] !== passengerCount) {
    t2 = () => {
      onChangePassengers(passengerCount);
    };
    $[2] = onChangePassengers;
    $[3] = passengerCount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== passengerCount) {
    t3 = [passengerCount];
    $[5] = passengerCount;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== PopoverClassName || $[8] !== chipsColor || $[9] !== iconColor || $[10] !== onAddPassengerCountList || $[11] !== onChange || $[12] !== onChangeChildAge || $[13] !== onClosePassengerButton || $[14] !== onDeletePassengerCountList || $[15] !== onSubmitPassengerCount || $[16] !== passengerCountList || $[17] !== passengerCountResult || $[18] !== passengerCountTitle || $[19] !== totalPassenger) {
    t4 = <PassengerRoomCountTour PopoverClassName={PopoverClassName} chipsColor={chipsColor} iconColor={iconColor} list={passengerCountList} onAdd={onAddPassengerCountList} onChange={onChange} onChangeChildAge={onChangeChildAge} onClosePassengerButton={onClosePassengerButton} onDelete={onDeletePassengerCountList} onSubmit={onSubmitPassengerCount} result={passengerCountResult} title={passengerCountTitle} totalPassenger={totalPassenger} />;
    $[7] = PopoverClassName;
    $[8] = chipsColor;
    $[9] = iconColor;
    $[10] = onAddPassengerCountList;
    $[11] = onChange;
    $[12] = onChangeChildAge;
    $[13] = onClosePassengerButton;
    $[14] = onDeletePassengerCountList;
    $[15] = onSubmitPassengerCount;
    $[16] = passengerCountList;
    $[17] = passengerCountResult;
    $[18] = passengerCountTitle;
    $[19] = totalPassenger;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
};